import { useState } from 'react';
import { applyUpdate, useSwUpdateAvailable } from './swUpdate';

/**
 * アプリの新バージョンが利用可能になったときに出す、非ブロッキングの「更新」バナー
 * (PWA prompt 方式、任意更新ボタン、2026-06-12)。
 *
 * 設計方針 (MultiTabBanner と同方針):
 *   - **強制リロードしない**。新版検出を知らせ、ユーザーが都合のよい時に「更新」を押す。
 *     （従来の autoUpdate は操作中でも勝手にリロードし、入力中の投稿が飛ぶ事故があり得た。）
 *   - 「久しぶりに開いた」人は待機中の新 SW が起動時に自動有効化されるため、本バナーは主に
 *     開いたまま使っている最中に新版が出たセッション向け。
 *   - × で閉じられる (後で更新可能、次回検出時に再表示)。
 *
 * 配置は App 直下に 1 つだけ。画面下部に fixed で浮かせ、全ルートで共通表示する。
 */
export function UpdateBanner() {
  const available = useSwUpdateAvailable();
  const [dismissed, setDismissed] = useState(false);
  if (!available || dismissed) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-2 pointer-events-none">
      <div
        className="mx-auto max-w-md bg-primary-700 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 pointer-events-auto"
        role="status"
      >
        <div className="flex-1 min-w-0">
          <p className="font-bold text-sm">新しいバージョンがあります</p>
          <p className="text-sm mt-0.5">「更新」を押すと最新版に切り替わります。</p>
        </div>
        <button
          type="button"
          onClick={applyUpdate}
          data-testid="update-banner-apply"
          className="shrink-0 inline-flex items-center rounded bg-white px-3 py-2 text-sm font-bold text-primary-800 hover:bg-slate-100 min-h-touch"
        >
          更新
        </button>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          data-testid="update-banner-dismiss"
          aria-label="閉じる"
          className="shrink-0 text-white text-xl px-2 min-h-touch min-w-touch hover:bg-white/10 rounded"
        >
          ×
        </button>
      </div>
    </div>
  );
}
